export default "__VITE_ASSET__ijZ2z_kx__"